<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <!-- <Toast style="margin-top: 35px" /> -->
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
            </div>
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button @click.prevent="searchInvoice"
                      class="p-button-raised" label="Search" icon="pi pi-search"/>
              <!-- <button type="submit" style="margin-left:10px;margin-top: 24px;"  @click.prevent="reset"
             class="btn btn-info pull-left">Reset</button> -->
            </div>
          </div>
        </form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <a href="#" @click.prevent="exportCSV()" v-if="this.purchaseInvoiceLists.length > 0 && this.$store.getters.modules.includes('5.38')">
              <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
            </a>
         <label style="color:red" for="name">Note: Please click search after update!<span
          style="color:red"></span></label>
            <DataTable :value="purchaseInvoiceLists"
                       ref="po"
                       :paginator="true" 
                       :rows="100" :filters="filters" :autoLayout="true"
                       :rowsPerPageOptions="[100,500,1000]"
                       class="p-datatable-responsive p-datatable-gridlines"
                       data-key="id"
                       :selection.sync="selectedProduct1" selectionMode="single">
              <Column header="S.N">
                <template #body="sl">
                  {{ sl.index + 1 }}
                </template>
              </Column>
              <Column header="Miti" headerStyle="width:8em;"  :sortable="true"
                      field="purchaseSalesDateNepali" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDateNepali']"/>
                </template>
              </Column>
              <Column header="Date" headerStyle="width:8em;"  :sortable="true" field="purchaseDate" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseDate']"/>
                </template>
              </Column>
              <Column header="Bill No" :sortable="true" field="billNo" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['billNo']"/>
                </template>
              </Column>
               <Column header="Ref No" :sortable="true" field="referenceNumber" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['referenceNumber']"/>
                </template>
              </Column>
              <Column header="Supplier" :sortable="true" field="accountName" filterMatchMode="contains">
                <template #body="slotProps">
                  <!-- {{ slotProps.data.accountMaster.name + ' (' + slotProps.data.accountName + ')' }} -->
                   {{ slotProps.data.accountMaster.name }}
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
                </template>
                <template #footer>
                  Total:
                </template>
              </Column>
              <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
                </template>
              </Column>
              <Column header="Store" :sortable="true" field="warehouse.name" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['warehouse.name']"/>
                </template>
              </Column>
              <Column header="Sub Total" bodyStyle="text-align: right" :sortable="true" field="subTotalAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['subTotalAmount']"/>
                </template>
                 <template #footer>
                  {{ totalSubAmount.toFixed(2) }}
                </template>
              </Column>

              <Column header="Non-taxable" bodyStyle="text-align: right" :sortable="true" field="nonTaxableAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['nonTaxableAmount']"/>
                </template>
                <template #footer>
                  {{ totalNonTaxableAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Taxable" bodyStyle="text-align: right" :sortable="true" field="taxableAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['taxableAmount']"/>
                </template>
                <template #footer>
                  {{ totalTaxableAmount.toFixed(2) }}
                </template>
              </Column>

              <Column header="Vat" bodyStyle="text-align: right" :sortable="true" field="vatAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['vatAmount']"/>
                </template>
                <template #footer>
                  {{ totalVatAmount.toFixed(2) }}
                </template>
              </Column>

              <Column header="Total" bodyStyle="text-align: right" :sortable="true" field="totalBillAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['totalBillAmount']"/>
                </template>
                <template #footer>
                  {{ totalSumBillAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Enter By" :sortable="true" field="enterBy" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['enterBy']"/>
                </template>
              </Column>
              <Column header="Update By" :sortable="true" field="updatedBy" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['updatedBy']"/>
                </template>
              </Column>
              <Column header="Action" headerStyle="width:13em">
                <template #body="slotProps">
                  <Button  icon="pi pi-pencil" class="p-button-raised p-button-success" v-tooltip.top="'Edit'"
                          @click="editPurchaseInvoice(slotProps.data)"/>
                  <Button icon="pi pi-trash" class="p-button-raised p-button-danger" v-tooltip.top="'Delete'"
                          @click="openDialog(slotProps.data.id)"/>
                  <Button icon="pi pi-eye" class="p-button-raised" v-tooltip.top="'View Details'"
                          @click="viewPIVDetail(slotProps.data)"/>
                  <Button class="p-button-raised p-button-warning" v-tooltip.top="'Print'"
                          @click="exportToPdf(slotProps.data.id)" icon="pi pi-print"/>
                  <Button class="p-button-raised p-button-info" @click="viewImage(slotProps.data.imageDTOSList)" v-tooltip.top="'View Image'" icon="pi pi-eye"/>
                </template>
                <template #empty>No record found</template>
              </Column>

            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <Dialogs header="View Image " :modal="true"
      :visible.sync="imageDialog" :style="{width: '50vw'}">
      <div>
        <Carousel :value="images">
          <template #item="slotProps">
            <!-- {{slotProps.data.name}} -->
            <div class="product-item">
              <div class="product-item-content">
               <div class="p-mb-3">
                   <img :src="slotProps.data.name"  style="height:250px;width:250px" class="product-image" />
               </div>
             </div>
           </div>
	        </template>
        </Carousel>
      </div>
    </Dialogs>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import Dialogs from 'primevue/dialog'

export default {
  name: 'purchaseInvoiceReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      // purchaseInvoiceLists: [],
      loading: false,
      dialogShow: false,
      selectedProduct1: null,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      enableEdit: false,
      enableDelete: false,
      images: null,
      imageDialog: false,
      totalSubAmount: 0,
      totalNonTaxableAmount: 0,
      totalTaxableAmount: 0,
      totalVatAmount: 0,
      totalSumBillAmount: 0,
      totalDiscountAmount: 0
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.checkEnableEdit()
    this.checkEnableDelete()
  },
  computed: {
    purchaseInvoiceLists() {
      return this.$store.state.purchase.purchaseInvoiceLists
    }
  },
  methods: {
    async searchInvoice() {
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadpurchaseInvoiceLists', dat)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Sorry! No data available.', life: 10000})
      }
      this.totalBalance()
    },
    async viewPIVDetail(data) {
      let PIHdata = {
        id: data.id,
        warehouse: data.warehouse,
        account: data.accountMaster,
        purchaseDate: data.purchaseSalesDateNepali,
        billNo: data.billNo,
        reportType: data.reportType,
        referenceNumber: data.referenceNumber,
        subTotalAmount: data.subTotalAmount,
        nonTaxableAmount: data.nonTaxableAmount,
        taxableAmount: data.taxableAmount,
        vatAmount: data.vatAmount,
        totalBillAmount: data.totalBillAmount,
        vatTypeEnum: data.vatTypeEnum,
        exciseChargeAmount: data.exciseChargeAmount,
        discountAmt: data.discount,
        remarks: data.remarks,
        supplierType: data.supplierType,
        shift: data.shift,
        amountInWords: data.amountInWords
      }
      if (data.purchaseType !== 'dairy') {
        this.$router.push({name: 'purchase Detail Report', params: {purchaseHeaderObj: PIHdata}})
      } else {
        this.$router.push({name: 'purchase Detail Dairy Report', params: {purchaseHeaderObj: PIHdata}})
      }
    },
    totalBalance() {
      this.totalSubAmount = 0.0
      this.totalNonTaxableAmount = 0.0
      this.totalTaxableAmount = 0.0
      this.totalVatAmount = 0.0
      this.totalSumBillAmount = 0.0
      this.totalDiscountAmount = 0.0
      for (let sale of this.purchaseInvoiceLists) {
        this.totalSubAmount += sale.subTotalAmount
        this.totalNonTaxableAmount += sale.nonTaxableAmount
        this.totalTaxableAmount += sale.taxableAmount
        this.totalVatAmount += sale.vatAmount
        this.totalSumBillAmount += sale.totalBillAmount
        this.totalDiscountAmount += sale.discount
      }
    },
    checkEnableEdit() {
      if (this.$store.getters.modules.includes(',5.07')) {
        this.enableEdit = true
      }
    },
    checkEnableDelete() {
      if (this.$store.getters.modules.includes(',5.11')) {
        this.enableDelete = true
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/purchaseInvoice' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'purchaseInvoice.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printPurchaseBill/' + SOHeaderId + '/purchaseInvoice' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'purchaseInvoice.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    viewImage(imageList) {
      this.images = imageList
      this.imageDialog = true
    },
    async editPurchaseInvoice(data) {
      let isEditData = {
        edit: data
      }
      this.$router.push({name: 'Purchase Invoice', params: {purchaseInvoice: isEditData}})
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        inventoryInHeaderId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deletePurchaseInvoice', deleteRe)
      if (resp.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.message, life: 10000})
        this.dialogShow = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.message, life: 10000})
        this.dialogShow = false
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.setEnglishDate()
      }
      // this.purchaseInvoiceLists = []
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    InputMask,
    Button,
    Dialogs
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// purchaseInvoiceReport.vue?0350b7f1